import {Liquid} from 'liquidjs';

const liquid = new Liquid({
  jsTruthy: true,
  extname: '.liquid',
});

export default liquid;
